import { render, staticRenderFns } from "./CentraTraficoIndex.vue?vue&type=template&id=6a0f9b2a"
import script from "./CentraTraficoIndex.vue?vue&type=script&lang=js"
export * from "./CentraTraficoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports